import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { GodRays } from "./GodRays";

export const Hero = () => {
  const scrollDown = () => {
    document
      .getElementById("ueber-mich")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden px-6"
    >
      {/* God rays streaming from top */}
      <GodRays />

      {/* Ambient glows */}
      <div
        className="ambient-glow"
        style={{
          width: 600,
          height: 600,
          background: "rgba(212, 175, 55, 0.18)",
          top: "-10%",
          left: "10%",
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="mb-10"
        >
          <span
            className="gold-divider"
            data-testid="hero-eyebrow"
          >
            Lichtmalerei · Fotokunst
          </span>
        </motion.div>

        <motion.h1
          data-testid="hero-quote"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.15 }}
          className="font-serif font-light leading-[1.05] tracking-tight text-3xl sm:text-5xl md:text-6xl lg:text-7xl max-w-5xl mx-auto"
        >
          <span className="text-[#E5E5E5]">Ich male nicht mit </span>
          <span className="italic text-[#E5E5E5]/70">Pinsel und Farbe.</span>
          <br className="hidden sm:block" />
          <span className="text-[#E5E5E5]"> Ich male mit </span>
          <span className="gold-text">Licht, Zeit</span>
          <span className="text-[#E5E5E5]"> und der </span>
          <span className="italic gold-text">Magie des Augenblicks.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut", delay: 0.4 }}
          className="mt-12 max-w-xl mx-auto text-[#A1A1AA] font-sans font-light text-sm md:text-base tracking-wide"
          data-testid="hero-subtext"
        >
          Werke aus Langzeitbelichtung, Bewegung und Dunkelheit —
          gemalt in einem einzigen Atemzug.
        </motion.p>

        <motion.button
          onClick={scrollDown}
          data-testid="hero-scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.6 }}
          className="mt-20 inline-flex flex-col items-center gap-3 text-[#D4AF37] group"
          aria-label="Nach unten scrollen"
        >
          <span className="text-[10px] uppercase tracking-[0.5em] font-sans font-light text-[#A1A1AA] group-hover:text-[#D4AF37] transition-colors">
            Entdecken
          </span>
          <motion.span
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
            className="inline-flex"
          >
            <ChevronDown size={20} strokeWidth={1.2} />
          </motion.span>
        </motion.button>
      </div>
    </section>
  );
};
